export default __webpack_public_path__ + "static/media/kathyfoodpic.50d9f596.jpg";